import { Observable } from 'rxjs';
import { combineEpics } from 'redux-observable';

import { INIT, WINDOW_AVAILABLE } from '../redux/app';
import { requestLocale, setUserAgent, setIOSDevice } from '../redux/env';
import { requestAccount } from '../redux/account';
import { fastpanelLoaded } from '../redux/fastpanel';

import { getUserAgent, isIOSDevice } from '../utils/browser';
import { configureFastpanel } from '../utils/fastpanel';
// import { setExperimentsUUID } from '../redux/experiments';
// import { getUUID } from '../utils/experiments';

import type { ActionObs, Store, Obs } from '../types';

export function initServerSideApp(action$: ActionObs, store: Store): Obs {
  return action$.ofType(INIT).mergeMap(() => {
    const userAgent = getUserAgent();
    const IOSDevice = isIOSDevice();

    return Observable.of(
      setUserAgent(userAgent),
      setIOSDevice(IOSDevice),
      // setExperimentsUUID(getUUID()),
      requestLocale(),
    );
  });
}

export function initClientSideApp(action$: ActionObs, store: Store): Obs {
  return action$.ofType(WINDOW_AVAILABLE).mergeMap(() => {
    const userAgent = getUserAgent();
    const IOSDevice = isIOSDevice();

    configureFastpanel().then(fastpanel => {
      const distinctId = fastpanel.get_distinct_id();
      const superId = fastpanel.get_property('superId');

      store.dispatch(fastpanelLoaded(distinctId, superId));
    });

    return Observable.of(
      setUserAgent(userAgent),
      setIOSDevice(IOSDevice),
      requestAccount(),
      // setExperimentsUUID(getUUID()),
      requestLocale(),
    );
  });
}

export default combineEpics(initServerSideApp, initClientSideApp);
